import API from '../../../../../services/api';

export const AUTORIZACIONES_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/autorizaciones-credito?page=${page}${search || ''}`).then(res => res.data);
    },
    update: async (pedido) => {
        return API.put('/autorizaciones-credito/' + pedido.id, pedido).then(res => res.data);
    },
    setPresupuesto: async() => {
        return API.post('autorizaciones-credito/set-presupuesto', {}).then(res => res.data);
    },
    getPosiblesPresupuestos: async (entity_id) => {
        return API.post('/autorizaciones-credito/posibles-presupuestos', {entity_id}).then(res => res.data);
    }
}